module.exports = __webpack_public_path__ + "static/media/bandage.8d2b5211.svg";